import { User } from './types';

export const USERS: User[] = [
  {
    firstName: 'Andrej',
    lastName: 'Badin',
  },
  {
    firstName: 'Jared',
    lastName: 'Palmer',
  },
];

export const BLANK_USER: User = {
  firstName: '',
  lastName: '',
};
